export const NAVBAR_HEIGHT = '86px';

export const CLOSED_SIDEBAR_WIDTH = (theme) => `calc(${theme.spacing(8)} + 1px)`;

export const OPEN_SIDEBAR_WIDTH = 340;
